import React from "react";
import moment from "moment";
import { getLabelByType, getMilestonePriorityPillClass, getMilestoneStatusPillClass } from "../../../helpers/utils";
import { displayDecimalFormatted, getAccountCurrency } from "../../../utils/systemSettings";
import SafeHtml from "../../../components/safeHtml/SafeHtml";
import { MilestoneIcon } from "../icons/icons";
import useNavigation from "../../../utils/useNavigation";


export const MilestonePopover = ({ milestones, position, settings, isPinned, onClose, onDragStart }) => {
    const { navigateTo } = useNavigation();
    const handleRedirect = (type, mielstone) => {

        if (type == "Program") {
            navigateTo("Programs", mielstone.program.id, mielstone.program.name);
        } else if (type == "Project") {
            navigateTo("Projects", mielstone.project.id, mielstone.project.name);
        }
    };
    return (
        <div
            className="absolute bg-white border border-gray-300 rounded-lg shadow-lg z-50 min-w-[300px] max-w-[500px]"
            style={{
                left: `${position.x}px`,
                top: `${position.y + 50}px`,
            }}
        >
            {isPinned && (
                <div
                    className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-[#ece7fd] rounded-t-lg cursor-move"
                    onMouseDown={onDragStart}
                >
                    <span className="text-xs font-semibold text-gray-700">
                        Milestone{milestones.length > 1 ? 's' : ''} Details - {moment(milestones[0].targetDate).format("MMM DD, YYYY")}
                    </span>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 focus:outline-none"
                        title="Close"
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12.8 4.27333L11.7267 3.2L8 6.92667L4.27333 3.2L3.2 4.27333L6.92667 8L3.2 11.7267L4.27333 12.8L8 9.07333L11.7267 12.8L12.8 11.7267L9.07333 8L12.8 4.27333Z"
                                fill="currentColor"
                            />
                        </svg>
                    </button>
                </div>
            )}
            <div className="p-4">
                <div className="space-y-3">
                    {milestones.map((milestone, index) => (
                        <div
                            key={milestone.id}
                            className={`${index > 0 ? "pt-3 border-t border-gray-200" : ""}`}
                        >
                            <div className="flex align-items-center gx-2 mb-2 space-x-2">
                                <MilestoneIcon size={16} />
                                <h4 className="font-semibold text-sm text-gray-900">
                                    {milestone.title}
                                </h4>
                            </div>

                            <div className="space-y-1 text-xs text-gray-600">
                                {
                                    (milestone.program || milestone.project) && (
                                        <div className="pl-[25px] mb-4">
                                            {
                                                milestone.program && (
                                                    <div className="flex justify-between pr-[5px]">
                                                        <span
                                                            className="font-medium text-[#342C82] redirectable"
                                                            onClick={() => handleRedirect("Program", milestone)}
                                                        >
                                                            {milestone.program.name}
                                                        </span>
                                                    </div>
                                                )
                                            }
                                            {
                                                milestone.project && (
                                                    <div className={`flex justify-between pr-[5px] ${milestone.program && 'pl-[10px]'}`}>
                                                        <span
                                                            className="font-medium text-[#342C82] redirectable"
                                                            onClick={() => handleRedirect("Project", milestone)}
                                                        >
                                                            {milestone.project.name}
                                                        </span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    )
                                }

                                <div className="flex justify-between pr-[5px] font-medium">
                                    <span>Target Date:</span>
                                    <span className="text-[#342C82]">{moment(milestone.targetDate).format("MMM DD, YYYY")}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="font-medium">Status:</span>
                                    <span>
                                        <div className="flex w-100 justify-center items-center font-medium">
                                            <p
                                                className={`${getMilestoneStatusPillClass(milestone.status)} w-100`}
                                                style={{ fontSize: '0.75rem', lineHeight: '1rem', fontWeight: '500' }}
                                            >
                                                {getLabelByType("milestoneStatus", milestone.status)}
                                            </p>
                                        </div>
                                    </span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="font-medium">Priority:</span>
                                    <span>
                                        <div className="flex w-100 justify-center items-center">
                                            <p
                                                className={`${getMilestonePriorityPillClass(milestone.priority)} w-100`}
                                                style={{ fontSize: '0.75rem', lineHeight: '1rem', fontWeight: '500' }}
                                            >
                                                {getLabelByType("milestonePriority", milestone.priority)}
                                            </p>
                                        </div>
                                    </span>
                                </div>
                                <div className="flex justify-between pr-[5px] font-medium">
                                    <span>Budget:</span>
                                    <span className="text-[#342C82]">
                                        {`${getAccountCurrency(settings)} ${displayDecimalFormatted(settings, milestone.budget)}`}
                                    </span>
                                </div>
                                {milestone.description && (
                                    <div className="mt-2">
                                        <span className="font-medium">Description:</span>
                                        <SafeHtml
                                            html={milestone.description}
                                            className={"mt-1 text-gray-700"}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
